import React, { FC, memo } from 'react';
import styled from '@emotion/styled';
import { useCurrency } from '~Hooks';
import { CartChild } from './types';

/** "+ 2 x Dip ........ 18 kr" - a quiet sub-row under the parent. */
const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  font-size: 12px;
  line-height: 1.3;
  color: var(--eposText);
`;

const Plus = styled.span`
  font-weight: 800;
  opacity: 0.4;
`;

const Title = styled.span`
  flex: 1;
  min-width: 0;
  font-weight: 600;
  opacity: 0.8;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Amount = styled.span`
  flex: 0 0 auto;
  white-space: nowrap;
  text-align: right;
  font-weight: 700;
  opacity: 0.5;
`;

interface Props {
  child: CartChild;
}

/** Display only - the parent's stepper edits the whole bundle. */
const CartChildLine: FC<Props> = ({ child }) => {
  const currency = useCurrency();

  return (
    <Row data-testid="epos-cart-child" data-item-id={child.itemId}>
      <Plus>+</Plus>
      <Title>
        {child.quantity > 1 ? `${child.quantity} × ` : ''}
        {child.title}
      </Title>
      <Amount>{currency.format(child.amount)}</Amount>
    </Row>
  );
};

export default memo(CartChildLine);
